import React from 'react';
import ComingSoon from '../../Components/comingSoon';

function AIProjects() {
  return <ComingSoon />;
}

export default AIProjects; 